import React, { memo } from 'react'
import { Card, Stack } from '@mui/material'

import { ACCOUNT_PROFILE_DISPATCH } from '../../store/reducers/account/account'
import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../shared/text/CardHeading'
import CustomTextField from '../shared/inputs/CustomTextField'
import CustomForm from '../shared/inputs/CustomForm'

const ChangeEmailAddress = ({
  onFormSubmit,
  dispatchAction,
  accountProfile: { error, success, emailTemp, email, isProcessing },
  t,
  isPresent
}) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CustomForm onFormSubmit={onFormSubmit}>
        <CardHeading title={t('user-account.change-email-address')} />
        <CustomTextField
          label={t('common.email-address')}
          error={t(error[ACCOUNT_PROFILE_DISPATCH.EMAIL_TEMP])}
          success={t(success[ACCOUNT_PROFILE_DISPATCH.EMAIL_TEMP])}
          value={emailTemp}
          onChange={(value) =>
            dispatchAction(ACCOUNT_PROFILE_DISPATCH.EMAIL_TEMP, value)
          }
        />
        <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
          <SubmitButton
            size='default'
            label={t('user-account.verify')}
            disabled={emailTemp === email}
            loading={isPresent && isProcessing}
          />
        </Stack>
      </CustomForm>
    </Card>
  )
}

export default memo(ChangeEmailAddress)
